// import { useParams } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import { getDatabase, ref, get } from 'firebase/database';
// import { database } from '../../auth/firebase';

// const HotelDetailPage = () => {
//   const { id } = useParams();
//   const [hotel, setHotel] = useState(null);

//   useEffect(() => {
//     // const db = getDatabase();
//     get(ref(database, `hotels/${id}`)).then((snapshot) => {
//       setHotel(snapshot.val());
//       console.log("hotel details:",hotel)
//     });
//   }, [id]);

//   if (!hotel) return <div className="p-10">Loading...</div>;

//   return (
//     <div className="p-6 md:px-20">
//       <h1 className="text-2xl font-bold mb-2">{hotel.name}</h1>
//       <p className="text-gray-600 mb-4">{hotel.description}</p>
//       <img
//         src={hotel.images?.hotel?.[0] || 'https://via.placeholder.com/300'}
//         className="w-full max-w-xl h-64 object-cover rounded mb-4"
//       />
//       <ul className="text-sm text-gray-700 mb-4 space-y-1">
//         <li><strong>Location:</strong> {hotel.location}</li>
//         <li><strong>Rating:</strong> {hotel.rating}</li>
//         <li><strong>Type:</strong> {hotel.type}</li>
//         <li><strong>Amenities:</strong> {hotel.amenities}</li>
//         <li><strong>Contact:</strong> {hotel.contact}</li>
//       </ul>
//     </div>
//   );
// };

// export default HotelDetailPage;




import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDatabase, ref, get } from "firebase/database";
import { database } from "../../auth/firebase";
import Footer from "../../common/Footer";
import Nav from "../../common/Nav";
import HotelImageGallery from "./HotelImageGallery";
import ResponsiveYouTube from "../../common/ResponsiveYoutube";
import YoutubeEmbed from "../../common/ResponsiveYoutube";
// import { app } from "../firebase"; // adjust path if needed

const HotelDetailPage = () => {
  const { id } = useParams(); // assuming route: /hotels/:id
  const [hotel, setHotel] = useState(null);

//   useEffect(() => {
//     // const db = getDatabase(app);

//     const fetchHotel = async () => {
//       try {
//         const snapshot = await get(ref(database, `hotels/${id}`));
//         if (snapshot.exists()) {
//           setHotel(snapshot.val());
//         } else {
//           console.log("No data found.");
//         }
//       } catch (error) {
//         console.error("Error fetching hotel:", error);
//       }
//     };

//     fetchHotel();
//   }, [id]);
// const videoId = ""
  useEffect(() => {
    // const db = getDatabase();
    get(ref(database, `hotels/${id}`)).then((snapshot) => {
      setHotel(snapshot.val());
      console.log("hotel details:",snapshot.val())
    });
  }, [id]);
  function getVideoIdFromIframe(iframeString) {
    if (!iframeString) return null; // handle undefined input
  console.log('user data :::::>>>',iframeString);
    const srcMatch = iframeString.match(/src="([^"]+)"/);
  
    if (srcMatch && srcMatch[1]) {
      try {
        const url = new URL(srcMatch[1]);
        const pathSegments = url.pathname.split("/"); // /embed/VIDEO_ID
        const videoId = pathSegments[pathSegments.length - 1]; // Extract last part
        return videoId.split("?")[0]; // Clean if there are query params
      } catch (error) {
        console.error("Invalid URL in iframe:", error);
        return null
      }
    } else {
      console.error("src not found in iframe HTML");
      return null
    }
  }
//   const videoId =  "<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/WphFQF05PP8?si=SKCDY2NrfyjTlMnw\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen></iframe>" && hotel.video;

console.log('vidoe id ::::>', hotel)
  if (!hotel) return <div className="p-4">Loading...</div>;

  return (

    <div className="bg-gray-100  flex flex-col min-h-screen h-screen w-screen  max-h-max p-0 m-0 ">
        <div>
            <Nav/>
        </div>
      {/* Image Grid */}
      <div className=" bg-gray-100 my-20">
      <HotelImageGallery
  images={[
    { src: hotel.images?.hotel?.[0] },
    { src: hotel.images?.rooms?.[0] },
    { src: hotel.images?.reception?.[0]},
    { src: hotel.images?.lobby?.[0] },
    { src: hotel.images?.amenities?.[0] },
  ]}
/>
      {/* <div className="bg-gray-500 grid grid-cols-1 md:grid-cols-3 gap-4  max-w-screen w-full">
        <img
          src={hotel.images?.hotel?.[0]}
          alt="Hotel"
          className="w-3/4 h-3/4 object-fit md:col-span-2 rounded-lg"
        />
        <div className="grid grid-cols-2  h-3/4  w-auto gap-4">
          <img src={hotel.images?.lobby?.[0]} alt="Lobby" className="object-cover h-full w-1/2 rounded-lg" />
          <img src={hotel.images?.reception?.[0]} alt="Reception" className="object-cover h-full w-1/2 rounded-lg" />
          <img src={hotel.images?.rooms?.[0]} alt="Room" className="object-cover h-full w-1/2 rounded-lg" />
          <img src={hotel.images?.amenities?.[0]} alt="Amenities" className="object-cover h-full w-1/2 rounded-lg" />
        </div>
        <div>
        </div>
      </div> */}

      {/* Static + Dynamic Info */}
      <div className="bg-gray-100 container mt-4 mx-8">
        <h2 className="text-2xl font-bold">{hotel.name}</h2>
        <p className="text-gray-600">{hotel.location}</p>
        <div className="flex items-center space-x-2 mt-2">
          <div className="bg-gray-800 text-white px-2 py-1 rounded">
            {hotel.rating}
          </div>
          <span className="text-sm text-gray-500">Excellent ·  Ratings</span>
        </div>
        <p className="mt-4 text-gray-900">{hotel.description}</p>

        {/* Static Facilities */}
        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2">Popular Facilities</h3>
          <div className="flex flex-wrap gap-4 text-sm">
            <span className="px-3 py-1 border rounded">Indoor Pool</span>
            <span className="px-3 py-1 border rounded">LAN Internet</span>
            <span className="px-3 py-1 border rounded">Breakfast</span>
            <span className="px-3 py-1 border rounded">24x7 Room Service</span>
            <span className="px-3 py-1 border rounded">Bar</span>
            <span className="px-3 py-1 border rounded">Fitness Center</span>
          </div>
        </div>
        {/* hotel video */}
        <div className=" bg-gray-100 py-10" >
            <YoutubeEmbed videoUrl={hotel.video}/>
         {/* <video
                        className=" bg-gray-400 top-0 left-0 w-full h-full object-cover"
                        autoPlay
                        loop
                        muted
                        
                        
                    >
                        <source src={hotel.video} type="video/mp4" />
                    </video>  */}
                    
                    {/* <iframe  className="top-0 left-0 w-full h-full object-cover" src={hotel.video} title="YouTube video player"></iframe> */}
        </div>
        {/* Contact & Type */}
        <div className="bg-gray-100 mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="font-semibold">Contact</h4>
            <p>{hotel.contact}</p>
          </div>
          <div>
            <h4 className="font-semibold">Type</h4>
            <p>{hotel.type}</p>
          </div>
        </div>
        <div>
        {/* <form
  action="https://formsubmit.co/rohit96soni@gmail.com"
  method="POST"
  className="space-y-4"
>
  <input type="hidden" name="_captcha" value="false" />
  <input type="text" name="name" placeholder="Name" required className="w-full border px-3 py-2 rounded" />
  <input type="email" name="email" placeholder="Email" required className="w-full border px-3 py-2 rounded" />
  <input type="text" name="contact" placeholder="Contact Number" required className="w-full border px-3 py-2 rounded" />
  <textarea name="message" placeholder="Message" required className="w-full border px-3 py-2 rounded"></textarea>
  <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded">Send</button>
</form> */}

        </div>
      </div>
      </div>
      <Footer/>
    </div>
  );
};

export default HotelDetailPage;
